<template>
    <!-- General  -->
    <div role="tablist" class="px-3-py-2">
    <b-card no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'generalLink'}" v-b-toggle.general variant="faded">1. General</b-button>
      </b-card-header>
      <b-collapse id="general" visible accordion="my-accordion" role="tabpanel">
          <b-list-group flush v-for="(item, index) in sortedGeneralContent" :key="index">
                <b-button class="left-aligner" block :to="/general/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

    <!-- Interventional  -->

    <b-card no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'interventionalLink'}" v-b-toggle.intCard variant="faded">2. Interventional Cardiology</b-button>
      </b-card-header>
      <b-collapse id="intCard" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedInterventionalContent" :key="index">
                <b-button class="left-aligner" block :to="/interventional/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

    <!-- Advanced Imaging  -->

    <b-card no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'advimgLink'}" v-b-toggle.advImg variant="faded">3. Advanced Imaging</b-button>
      </b-card-header>
      <b-collapse id="advImg" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedAdvImgContent" :key="index">
                <b-button class="left-aligner" block :to="/advimg/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

    <!-- Electrophysiology  -->

    <b-card no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'epLink'}" v-b-toggle.ep variant="faded">4. Electrophysiology</b-button>
      </b-card-header>
      <b-collapse id="ep" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedEpContent" :key="index">
                <b-button class="left-aligner" block :to="/ep/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

    <!-- Advanced HF and Txp  -->

    <b-card no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'advhfLink'}" v-b-toggle.advHf variant="faded">5. Advanced Heart Failure/Transplant</b-button>
      </b-card-header>
      <b-collapse id="advHf" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedAdvHfContent" :key="index">
                <b-button class="left-aligner" block :to="/advhf/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

    <!-- Crtical Care Cardiology  -->

    <b-card no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'cccLink'}" v-b-toggle.ccc variant="faded">6. Critical Care</b-button>
      </b-card-header>
      <b-collapse id="ccc" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedCccContent" :key="index">
                <b-button class="left-aligner" block :to="/ccc/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

    <!-- Institutional Algorithms  -->

    <b-card no-body v-show=false class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'algorithmsLink'}" v-b-toggle.algorithms variant="faded">7. Institutional Algorithms</b-button>
      </b-card-header>
      <b-collapse id="algorithms" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedAlgorithmContent" :key="index">
                <b-button class="left-aligner" block :to="/algorithms/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

  <!-- Other / Congenital -->

       <b-card v-show=false no-body class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'otherLink'}" v-b-toggle.other variant="faded">8. Congenital</b-button>
      </b-card-header>
      <b-collapse id="other" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedOthersContent" :key="index">
                <b-button class="left-aligner" block :to="/other/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>
    
    <!-- Non-Cardiology  -->

    <b-card no-body v-show=false class="mb-n1">
      <b-card-header header-tag="header" class="p-4" role="tab">
        <b-button class="text-left" block :to="{name: 'noncardsLink'}" v-b-toggle.nonCards variant="faded">9. Non-Cardiology</b-button>
      </b-card-header>
      <b-collapse id="nonCards" accordion="my-accordion" role="tabpanel">
        <b-list-group flush v-for="(item, index) in sortedNonCardsContent" :key="index">
                <b-button class="left-aligner" block :to="/noncards/+item.ref" squared variant="link">{{ item.name }}</b-button>
        </b-list-group>
      </b-collapse>
    </b-card>

  

  </div>
</template>

<script src="https://cdn.jsdelivr.net/lodash/4.13.1/lodash.js"></script>

<script>
    
    import {mapGetters} from 'vuex'  


    export default {
        
        name: "sidebar",
        components: {
        },
        computed: {
            ...mapGetters([
                'getGeneralContent',
                    'getInterventionalContent',
                    'getEpContent',
                    'getAdvImgContent',
                    'getAdvHfContent',
                    'getAlgorithmContent',
                    'getNonCardsContent',
                    'getOthersContent',
                    'getCccContent',
            ]),
            sortedGeneralContent: function () {
                return _.orderBy(this.getGeneralContent, 'order')
            },
            sortedInterventionalContent: function () {
                return _.orderBy(this.getInterventionalContent, 'order')
            },
            sortedEpContent: function () {
                return _.orderBy(this.getEpContent, 'order')
            },
            sortedAdvImgContent: function () {
                return _.orderBy(this.getAdvImgContent, 'order')
            },
            sortedAdvHfContent: function () {
                return _.orderBy(this.getAdvHfContent, 'order')
            },
            sortedAlgorithmContent: function () {
                return _.orderBy(this.getAlgorithmContent, 'order')
            },
            sortedNonCardsContent: function () {
                return _.orderBy(this.getNonCardsContent, 'order')
            },
            sortedOthersContent: function () {
                return _.orderBy(this.getOthersContent, 'order')
            },
            sortedCccContent: function () {
                return _.orderBy(this.getCccContent, 'order')
            },


        },
    }

</script>

<style scoped>

.mb-n1, .my-n1 {
    max-width: 20vw !important;
  }
.px-3-py-2 {
    padding-left: 0rem;
    padding-top: 0.3rem;

  }

   a{
    max-width: 18vw;
  }


    .left-aligner {
        text-align: left;
        padding-left: 2em;
        color: black;
    }
</style>